var map = {
	"./add-file-company.jpg": 2740,
	"./add-file-worker.jpg": 7439,
	"./advanced_logo.svg": 1606,
	"./alm.svg": 3381,
	"./avatar.jpeg": 5886,
	"./calendar-sync.svg": 396,
	"./calendar.svg": 1972,
	"./car.png": 4838,
	"./coming-soon.svg": 9113,
	"./companies.svg": 4351,
	"./consult-branches.svg": 23,
	"./consult-calendar.svg": 4753,
	"./consult-hubs.svg": 5347,
	"./consult-service-point.svg": 7893,
	"./enterprise_logo.svg": 3655,
	"./error.svg": 7620,
	"./essential_logo.svg": 7100,
	"./final-step-calizy.svg": 996,
	"./forgot-password.svg": 8980,
	"./icon-calendar.svg": 8968,
	"./icon-case.svg": 2630,
	"./icon-team.svg": 7197,
	"./import-file.svg": 9456,
	"./invitation-preview-001.png": 5814,
	"./invitation-preview-002.png": 7581,
	"./link-sent.svg": 3613,
	"./log-out.svg": 4075,
	"./login-image.svg": 4545,
	"./logo.svg": 7839,
	"./manual.svg": 7252,
	"./microsoft-logo.svg": 7342,
	"./my-company.svg": 118,
	"./onboarding-success.svg": 9131,
	"./onboarding.svg": 9469,
	"./partners-company.svg": 2853,
	"./progress.svg": 1815,
	"./success.svg": 7487,
	"./workers.svg": 7271,
	"./working-hours.svg": 694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6028;